import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  className = '',
  disabled = false,
  type = 'button',
  icon: Icon,
  ...props
}) => {
  const variantClass = `btn-${variant}`;
  const sizeClass = size !== 'md' ? `btn-${size}` : '';

  // Guard: only render if Icon is a valid component (function, string, or forwardRef/object with $$typeof)
  const canRenderIcon =
    Icon &&
    (typeof Icon === 'function' ||
      typeof Icon === 'string' ||
      (typeof Icon === 'object' && Icon.$$typeof));

  if (Icon && !canRenderIcon) {
    // Log so we can find the offender
    console.error('[Button] Invalid icon prop received:', Icon);
  }

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn ${variantClass} ${sizeClass} ${className}`}
      {...props}
    >
      {canRenderIcon ? <Icon size={18} /> : null}
      {children}
    </button>
  );
};

export default Button;